// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var sequent_backend_trustee = {
    __typename: undefined,
    annotations: undefined,
    created_at: undefined,
    id: "",
    labels: undefined,
    last_updated_at: undefined,
    name: undefined,
    public_key: undefined,
    tenant_id: undefined,
};
export var sequent_backend_report = {
    created_at: undefined,
    cron_config: undefined,
    election_event_id: undefined,
    election_id: undefined,
    id: undefined,
    report_type: "",
    template_alias: undefined,
    tenant_id: undefined,
    encryption_policy: "",
};
export var sequent_backend_tenant = {
    __typename: undefined,
    annotations: undefined,
    created_at: "",
    id: "",
    is_active: true,
    labels: undefined,
    settings: undefined,
    slug: "",
    updated_at: "",
    voting_channels: undefined,
};
export var sequent_backend_tally_sheet = {
    __typename: undefined,
    annotations: undefined,
    area_id: "",
    channel: undefined,
    content: undefined,
    contest_id: "",
    created_at: "",
    created_by_user_id: "",
    deleted_at: undefined,
    election_event_id: "",
    election_id: "",
    id: "",
    import_id: undefined,
    labels: undefined,
    last_updated_at: undefined,
    reviewed_at: undefined,
    reviewed_by_user_id: "",
    tenant_id: "",
    version: 0,
    status: "",
};
export var sequent_backend_tally_session_execution = {
    __typename: undefined,
    annotations: undefined,
    created_at: undefined,
    current_message_id: 0,
    election_event_id: "",
    id: "",
    labels: undefined,
    last_updated_at: undefined,
    results_event_id: undefined,
    session_ids: undefined,
    status: undefined,
    tally_session_id: "",
    tenant_id: "",
    documents: undefined,
};
export var sequent_backend_tally_session_contest = {
    __typename: undefined,
    annotations: undefined,
    area_id: "",
    contest_id: "",
    created_at: undefined,
    election_event_id: "",
    election_id: "",
    id: "",
    labels: undefined,
    last_updated_at: undefined,
    session_id: 0,
    tally_session_id: "",
    tenant_id: "",
};
export var sequent_backend_tally_session = {
    __typename: undefined,
    annotations: undefined,
    area_ids: undefined,
    created_at: undefined,
    election_event_id: "",
    election_ids: undefined,
    execution_status: undefined,
    id: "",
    is_execution_completed: true,
    keys_ceremony_id: "",
    labels: undefined,
    last_updated_at: undefined,
    resolutions: [],
    resolutions_aggregate: { nodes: [] },
    tenant_id: "",
    threshold: 0,
};
export var sequent_backend_support_material = {
    __typename: undefined,
    annotations: undefined,
    created_at: "",
    data: undefined,
    document_id: undefined,
    election_event_id: "",
    id: "",
    is_hidden: undefined,
    kind: "",
    labels: undefined,
    last_updated_at: "",
    tenant_id: "",
};
var sequent_backend_area = {
    __typename: undefined,
    annotations: undefined,
    created_at: undefined,
    description: undefined,
    election_event_id: "",
    id: "",
    labels: undefined,
    last_updated_at: undefined,
    name: undefined,
    tenant_id: "",
    type: undefined,
    presentation: undefined,
};
export var sequent_backend_area_contest = {
    __typename: undefined,
    annotations: undefined,
    area: undefined,
    area_id: undefined,
    contest: undefined,
    contest_id: undefined,
    created_at: undefined,
    election_event_id: undefined,
    id: "",
    labels: undefined,
    last_updated_at: undefined,
    tenant_id: undefined,
};
export var sequent_backend_ballot_publication = {
    __typename: undefined,
    annotations: undefined,
    created_at: "",
    created_by_user_id: undefined,
    deleted_at: undefined,
    election_event_id: "",
    election_id: undefined,
    election_ids: undefined,
    id: "",
    is_generated: true,
    labels: undefined,
    published_at: undefined,
    tenant_id: "",
};
export var sequent_backend_ballot_style = {
    __typename: undefined,
    annotations: undefined,
    area_id: undefined,
    ballot_eml: undefined,
    ballot_publication_id: "",
    ballot_signature: undefined,
    created_at: undefined,
    deleted_at: undefined,
    election_event_id: "",
    election_id: "",
    id: "",
    labels: undefined,
    last_updated_at: undefined,
    status: undefined,
    tenant_id: "",
};
export var sequent_backend_template = {
    __typename: undefined,
    annotations: undefined,
    communication_method: "",
    type: "",
    created_at: "",
    created_by: "",
    id: "",
    labels: undefined,
    template: undefined,
    tenant_id: "",
    updated_at: "",
};
export var sequent_backend_contest = {
    __typename: undefined,
    annotations: undefined,
    candidates: [],
    candidates_aggregate: {},
    conditions: undefined,
    counting_algorithm: undefined,
    created_at: undefined,
    description: undefined,
    election_event_id: "",
    election_id: "",
    id: "",
    image_document_id: undefined,
    is_acclaimed: undefined,
    is_active: undefined,
    is_encrypted: undefined,
    labels: undefined,
    last_updated_at: undefined,
    max_votes: undefined,
    min_votes: undefined,
    presentation: undefined,
    tally_configuration: undefined,
    tenant_id: "",
    voting_type: undefined,
    winning_candidates_num: undefined,
};
export var sequent_backend_document = {
    __typename: undefined,
    annotations: undefined,
    created_at: undefined,
    election_event_id: undefined,
    id: "",
    is_public: undefined,
    labels: undefined,
    last_updated_at: undefined,
    media_type: undefined,
    name: undefined,
    size: undefined,
    tenant_id: undefined,
};
export var sequent_backend_election = {
    __typename: undefined,
    annotations: undefined,
    contests: [],
    contests_aggregate: {},
    created_at: undefined,
    description: undefined,
    election_event_id: "",
    eml: undefined,
    external_id: undefined,
    id: "",
    image_document_id: undefined,
    is_consolidated_ballot_encoding: undefined,
    is_kiosk: undefined,
    labels: undefined,
    last_updated_at: undefined,
    num_allowed_revotes: undefined,
    presentation: undefined,
    receipts: undefined,
    spoil_ballot_option: undefined,
    statistics: undefined,
    status: undefined,
    tenant_id: "",
    voting_channels: undefined,
};
export var sequent_backend_election_event = {
    __typename: undefined,
    annotations: undefined,
    audit_election_event_id: undefined,
    bulletin_board_reference: undefined,
    created_at: undefined,
    description: undefined,
    elections: [],
    elections_aggregate: {},
    encryption_protocol: "",
    id: "",
    is_archived: true,
    is_audit: undefined,
    labels: undefined,
    presentation: undefined,
    public_key: undefined,
    statistics: undefined,
    status: undefined,
    tenant_id: "",
    updated_at: undefined,
    user_boards: undefined,
    voting_channels: undefined,
};
export var sequent_backend_election_result = {
    __typename: undefined,
    annotations: undefined,
    area_id: undefined,
    created_at: undefined,
    election_event_id: undefined,
    election_id: undefined,
    id: "",
    labels: undefined,
    last_updated_at: undefined,
    result_eml: undefined,
    result_eml_signature: undefined,
    statistics: undefined,
    tenant_id: undefined,
};
export var sequent_backend_election_type = {
    __typename: undefined,
    annotations: undefined,
    created_at: "",
    id: "",
    labels: undefined,
    name: "",
    tenant_id: "",
    updated_at: "",
};
export var sequent_backend_event_execution = {
    __typename: undefined,
    annotations: undefined,
    election_event_id: undefined,
    ended_at: undefined,
    execution_payload: undefined,
    execution_state: undefined,
    id: "",
    labels: undefined,
    result_payload: undefined,
    scheduled_event_id: "",
    started_at: undefined,
    tenant_id: undefined,
};
export var sequent_backend_keys_ceremony = {
    __typename: undefined,
    annotations: undefined,
    created_at: "",
    election_event_id: "",
    execution_status: undefined,
    id: "",
    keys_ceremony_trustee_ids: [],
    keys_ceremony_trustee_ids_aggregate: {},
    labels: undefined,
    last_updated_at: "",
    status: undefined,
    tenant_id: "",
    threshold: 1,
    trustee_ids: [],
    name: "",
    settings: {},
    is_default: true,
};
export var sequent_backend_lock = {
    __typename: undefined,
    created_at: "",
    expiry_date: undefined,
    key: "",
    last_updated_at: undefined,
    value: "",
};
export var sequent_backend_results_area_contest = {
    __typename: undefined,
    annotations: undefined,
    area_id: "",
    contest_id: "",
    created_at: undefined,
    documents: undefined,
    election_event_id: "",
    election_id: "",
    elegible_census: undefined,
    explicit_blank_votes: undefined,
    explicit_blank_votes_percent: undefined,
    explicit_invalid_votes: undefined,
    explicit_invalid_votes_percent: undefined,
    id: "",
    implicit_blank_votes: undefined,
    implicit_blank_votes_percent: undefined,
    implicit_invalid_votes: undefined,
    implicit_invalid_votes_percent: undefined,
    labels: undefined,
    last_updated_at: undefined,
    results_event_id: "",
    tenant_id: "",
    total_blank_votes: undefined,
    total_blank_votes_percent: undefined,
    total_invalid_votes: undefined,
    total_invalid_votes_percent: undefined,
    total_valid_votes: undefined,
    total_valid_votes_percent: undefined,
    total_votes: undefined,
    total_votes_percent: undefined,
};
export var sequent_backend_results_area_contest_candidate = {
    __typename: undefined,
    annotations: undefined,
    area_id: "",
    candidate_id: "",
    cast_votes: undefined,
    cast_votes_percent: undefined,
    contest_id: "",
    created_at: undefined,
    documents: undefined,
    election_event_id: "",
    election_id: "",
    id: "",
    labels: undefined,
    last_updated_at: undefined,
    points: undefined,
    results_event_id: "",
    tenant_id: "",
    winning_position: undefined,
};
export var sequent_backend_results_election_area = {
    __typename: undefined,
    area_id: "",
    created_at: undefined,
    documents: undefined,
    election_event_id: "",
    election_id: "",
    id: "",
    results_event_id: "",
    tenant_id: "",
    last_updated_at: undefined,
};
export var sequent_backend_results_contest = {
    __typename: undefined,
    annotations: undefined,
    contest_id: "",
    counting_algorithm: undefined,
    created_at: undefined,
    documents: undefined,
    election_event_id: "",
    election_id: "",
    elegible_census: undefined,
    explicit_blank_votes: undefined,
    explicit_blank_votes_percent: undefined,
    explicit_invalid_votes: undefined,
    explicit_invalid_votes_percent: undefined,
    id: "",
    implicit_blank_votes: undefined,
    implicit_blank_votes_percent: undefined,
    implicit_invalid_votes: undefined,
    implicit_invalid_votes_percent: undefined,
    labels: undefined,
    last_updated_at: undefined,
    name: undefined,
    results_event_id: "",
    tenant_id: "",
    total_blank_votes: undefined,
    total_blank_votes_percent: undefined,
    total_invalid_votes: undefined,
    total_invalid_votes_percent: undefined,
    total_valid_votes: undefined,
    total_valid_votes_percent: undefined,
    total_votes: undefined,
    total_votes_percent: undefined,
    voting_type: undefined,
};
export var sequent_backend_results_contest_candidate = {
    __typename: undefined,
    annotations: undefined,
    candidate_id: "",
    cast_votes: undefined,
    cast_votes_percent: undefined,
    contest_id: "",
    created_at: undefined,
    documents: undefined,
    election_event_id: "",
    election_id: "",
    id: "",
    labels: undefined,
    last_updated_at: undefined,
    points: undefined,
    results_event_id: "",
    tenant_id: "",
    winning_position: undefined,
};
export var sequent_backend_results_election = {
    __typename: undefined,
    annotations: undefined,
    created_at: undefined,
    documents: undefined,
    election_event_id: "",
    election_id: "",
    elegible_census: undefined,
    id: "",
    labels: undefined,
    last_updated_at: undefined,
    name: undefined,
    results_event_id: "",
    tenant_id: "",
    total_voters: undefined,
    total_voters_percent: undefined,
};
export var sequent_backend_scheduled_event = {
    __typename: undefined,
    annotations: undefined,
    created_at: undefined,
    archived_at: undefined,
    created_by: undefined,
    cron_config: undefined,
    election_event_id: undefined,
    event_payload: undefined,
    event_processor: undefined,
    id: "",
    labels: undefined,
    stopped_at: undefined,
    task_id: undefined,
    tenant_id: undefined,
};
export var sequent_backend_tasks_execution = {
    __typename: undefined,
    annotations: undefined,
    created_at: undefined,
    election_event_id: undefined,
    end_at: undefined,
    executed_by_user: "",
    execution_status: "",
    id: undefined,
    labels: undefined,
    logs: undefined,
    name: "",
    start_at: undefined,
    /** An object relationship */
    tenant: {},
    tenant_id: undefined,
    type: "",
};
export var sequent_backend_preview = {
    __typename: undefined,
    id: undefined,
    tenant_id: undefined,
    document_id: undefined,
    url: "",
    requested_by: "",
    updated_at: undefined,
    created_at: undefined,
    annotations: undefined,
};
export var COLUMNS_MAP = {
    sequent_backend_area: Object.keys(sequent_backend_area),
    sequent_backend_trustee: Object.keys(sequent_backend_trustee),
    sequent_backend_tenant: Object.keys(sequent_backend_tenant),
    sequent_backend_tally_sheet: Object.keys(sequent_backend_tally_sheet),
    sequent_backend_tally_session_execution: Object.keys(sequent_backend_tally_session_execution),
    sequent_backend_tally_session_contest: Object.keys(sequent_backend_tally_session_contest),
    sequent_backend_tally_session: Object.keys(sequent_backend_tally_session),
    sequent_backend_support_material: Object.keys(sequent_backend_support_material),
    sequent_backend_area_contest: Object.keys(sequent_backend_area_contest),
    sequent_backend_ballot_publication: Object.keys(sequent_backend_ballot_publication),
    sequent_backend_ballot_style: Object.keys(sequent_backend_ballot_style),
    sequent_backend_template: Object.keys(sequent_backend_template),
    sequent_backend_contest: Object.keys(sequent_backend_contest),
    sequent_backend_document: Object.keys(sequent_backend_document),
    sequent_backend_election: __spreadArray(__spreadArray([], Object.keys(sequent_backend_election), true), [
        "keys_ceremony_id",
        "external_id",
    ], false),
    sequent_backend_election_event: Object.keys(sequent_backend_election_event),
    sequent_backend_election_result: Object.keys(sequent_backend_election_result),
    sequent_backend_election_type: Object.keys(sequent_backend_election_type),
    sequent_backend_event_execution: Object.keys(sequent_backend_event_execution),
    sequent_backend_keys_ceremony: Object.keys(sequent_backend_keys_ceremony),
    sequent_backend_lock: Object.keys(sequent_backend_lock),
    sequent_backend_results_area_contest: Object.keys(sequent_backend_results_area_contest),
    sequent_backend_results_area_contest_candidate: Object.keys(sequent_backend_results_area_contest_candidate),
    sequent_backend_results_contest: Object.keys(sequent_backend_results_contest),
    sequent_backend_results_contest_candidate: Object.keys(sequent_backend_results_contest_candidate),
    sequent_backend_results_election: Object.keys(sequent_backend_results_election),
    sequent_backend_results_election_area: Object.keys(sequent_backend_results_election_area),
    sequent_backend_scheduled_event: Object.keys(sequent_backend_scheduled_event),
    sequent_backend_tasks_execution: Object.keys(sequent_backend_tasks_execution),
    sequent_backend_preview: Object.keys(sequent_backend_preview),
};
